import { Component } from '@angular/core';

@Component({
  selector: 'app-features-main',
  templateUrl: './features-main.component.html',
  styleUrls: ['./features-main.component.css']
})
export class FeaturesMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
